module.exports = __webpack_public_path__ + "static/media/ae.1d281ed9.svg";